export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '排气温度(℃)',
    en: 'Exhaust Temperature(℃)',
    dataIndex: 'exhaustTemperature',
    key: 'exhaustTemperature'
  },
  {
    zh: '进气温度(℃)',
    en: 'Inlet Temperature',
    dataIndex: 'inletTemperature',
    key: 'inletTemperature'
  },
  {
    zh: '电机轴承温度(℃)',
    en: 'Motor Bearing Temperature(℃)',
    dataIndex: 'motorBearingTemperature',
    key: 'motorBearingTemperature'
  },
  {
    zh: '电机绕组温度(℃)',
    en: 'Motor Winding Temperature(℃)',
    dataIndex: 'motorWindingTemperature',
    key: 'motorWindingTemperature'
  },
  {
    zh: '累积运行时间(h)',
    en: 'Run Time',
    dataIndex: 'runTime',
    key: 'runTime'
  },
  {
    zh: '持续时间(h)',
    en: 'Duration',
    dataIndex: 'duration',
    key: 'duration'
  }
]